// extracted by css-extract-rspack-plugin
export default {"homeInputWrap":"homeInputWrap-ACsRlJ","sidebarToggleAligned":"sidebarToggleAligned-O0_nWf"};